<mat-toolbar color="primary">
    <span>{{title}}</span>
    <span class="toolbar-spacer"></span>
</mat-toolbar>
<mat-dialog-content>
    <mat-form-field class="field-full-width" appearance="legacy">
        <mat-label>{{fieldName}}</mat-label>
        <input matInput placeholder="{{fieldName}}" [(ngModel)]="field" value="">
    </mat-form-field>    
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button (click)="ok()">{{okMsg}}</button>
    <button mat-button (click)="cancel()">{{cancelMsg}}</button>
</mat-dialog-actions>